import { validate } from 'uuid';

import { WorkspaceId } from '~app-client/workspaces/types';

import { unassignedWorkspaceId } from './extra-workspaces.utils';

export function isPersistedWorkspaceId(id: WorkspaceId): boolean {
	return validate(id);
}

export function isStoredWorkspaceId(id: unknown): id is WorkspaceId {
	return typeof id === 'string' && (validate(id) || id === unassignedWorkspaceId);
}
